<template>
  	<FlexPinBatchList />
</template>

<script>

// @ is an alias to /src
import FlexPinBatchList from "@/components/Flex/PinBatchList.vue";

export default {
  name: "FlexPinBatchLists",
  components: {
    FlexPinBatchList,
  },
};
</script>
